import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery } from '@percent/partner-dashboard/common/hooks'
import { ProgramsTable } from './programsTable/ProgramsTable'

export function ProgramsContainer() {
  const { grantsService } = useServices()
  const { t } = useTranslation()

  useBreadcrumbs([
    {
      label: t('breadcrumb.grants')
    }
  ])

  const [{ data: grantPrograms, isLoading: isLoadingPrograms }] = useQuery(grantsService.getPrograms, {})

  return (
    <div data-testid="programs-container">
      <ProgramsTable data={grantPrograms} isLoading={isLoadingPrograms} totalResults={grantPrograms?.length ?? 0} />
    </div>
  )
}
